import { Box, Typography } from "@mui/material";

export default function AgentTest() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Test de l’agent</Typography>
      <Typography color="text.secondary">
        Simulez des interactions avec l’agent.
      </Typography>
    </Box>
  );
}
